import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IIndexShipping, IShippingConfirm, Membership, ShippingConfirm } from 'src/app/shared/Models/IShipping';
import { ShippingService } from 'src/app/shared/services/shipping.service';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ShippingDetails',
  templateUrl: './ShippingDetails.component.html',
  styleUrls: ['./ShippingDetails.component.scss']
})
export class ShippingDetailsComponent implements OnInit {

  shipping$: Observable<IIndexShipping>;
  membershipType: number = 1;
  isConfirm = false;
  subTotal = 0;
  totalPrice = 0;
  amountDiscountByCoupon = 0;
  isKurdish = false;

  height = 0;
  width = 0;
  length = 0;
  weightByWidthLengthHeight = 0;

  usaTax = 0;
  localUSShipping = 0;
  totalItemPrice = 0;

  constructor(private _shippingService: ShippingService,
    private _location: Location
  ) {
    var kurdishLanguage = localStorage.getItem('code');
    if (kurdishLanguage) {
      this.isKurdish = true;
    }
  }

  ngOnInit() {
    this.shipping$ = this._shippingService.getShipping$;
    this.shipping$.subscribe((data: IIndexShipping) => {


      var membershipInNumber = Number(data.membership);
      if (membershipInNumber == 3) {
        this.membershipType = 3;
      }

      if (membershipInNumber == 2) {
        this.membershipType = 2;
      }

      if (data.height > 0 && data.width > 0 && data.length > 0) {
        this.weightByWidthLengthHeight = (data.height * data.width * data.length) / 145;
      }

      // var intShipping = data.internationalShippingAmount;
      const intShipping = data.internationalShippingAmount > 0 ? data.weight * data.internationalShippingAmount :
        this.membershipType === 3
          ? data.weight * 7
          : data.weight * 8;
      // var tax = data.itemPrice * (data.tax>0?data.tax:10)/100 ;
      this.usaTax = ((data.itemPrice * (data.tax > 0 ? data.tax : 10)) / 100) * data.quantity;

      var insuranceAmount = data.insurance ? 2.90 : 0;
      var expressAmount = data.expressShipping ? data.weight * 1.90 : 0;
      var extraFee = data.extraFee;




      data.totalPrice =
        (data.quantity * data.itemPrice) +
        intShipping +
        this.usaTax +
        this.localUSShipping +
        insuranceAmount +
        expressAmount +
        extraFee +
        data.commission;

      this.subTotal = data.totalPrice;

      this.amountDiscountByCoupon = ((data.totalPrice * data.couponPercentage) / 100) + data.discount;


      this.totalPrice = data.totalPrice - this.amountDiscountByCoupon;
    })

  }

  openLink(link: string) {
    window.open(link)
  }

  goBack() {
    this._location.back();
  }


  public onDisplayImage = (serverPath: string) => {
    let imageApi = environment.imageApi;
    var result = `${imageApi}/${serverPath}`;

    return result;
  };

  intShipping(weight: number) {

    switch (this.membershipType) {
      case 3:
        return weight * 7;
      case 2:
        return weight * 8;
      default:
        return weight * 8;
    }
  }

  onConfirm(shippingId: number, confirmStatus: number) {
    var shippingConfirmStatus: IShippingConfirm = {
      shippingId: shippingId,
      shippingConfirm: confirmStatus == 1 ? ShippingConfirm.Confirm : ShippingConfirm.Cancel
    }
    this._shippingService.UpdateShippingConfirm(shippingConfirmStatus)
      .subscribe((shipping: IIndexShipping) => {
      })
  }

  memberShip(weight: number) {

    switch (this.membershipType) {
      case 3:
        return 7;
      case 2:
        return 8;
      default:
        return 8;
    }
  }


}
